<fcom-icon-button
  [theme]="isOpen ? IconButtonTheme.DARK_TERTIARY_GHOST : IconButtonTheme.LIGHT_TERTIARY_GHOST"
  [icon]="{
    name: isOpen ? SvgLibraryIcon.CHEVRON_LEFT : SvgLibraryIcon.MENU_LIST,
  }"
  [aria]="{
    label: (isOpen ? 'menu.close' : 'menu.open') | finLocalization,
  }"
  (clickBtn)="toggleMenu()"
/>
